<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('allowanceCondition.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('allowanceCondition.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
              <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-text-center">{{ record.pg_level }}</td>
            <td class="text-right">{{ record.meal_allowance }}</td>
            <td class="text-right">{{ record.accommodation_allowance }}</td>
            <td class="text-right">{{ record.day_return_allowance }}</td>
            <td class="ts-text-center">
              <a-switch
                v-model="record.is_active"
                size="small"
                :loading="record.loading_active"
                @change="switchActive(record)"
              />
            </td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData" />
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('allowanceCondition.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action
          @cancel="() => (showForm = false)"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FromAction from './form'
export default {
  name: 'AllowanceCondition',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('mission/allowanceCondition', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('allowanceCondition.pgLevel'),
          style: 'text-align:center; width:94px'
        },
        {
          name: this.$t('allowanceCondition.mealAllowance'),
          style: 'text-align:right'
        },
        {
          name: this.$t('allowanceCondition.accommodationAllowance'),
          style: 'text-align:right'
        },
        {
          name: this.$t('allowanceCondition.dayReturnAllowance'),
          style: 'text-align:right'
        },
        {
          name: this.$t('allowanceCondition.IsActive'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:94px' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('mission/allowanceCondition/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.$store.commit('mission/allowanceCondition/SET_EDIT_DATA', {})
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('mission/allowanceCondition/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('mission/allowanceCondition/SET_EDIT_DATA', {})
      this.showForm = false
    },
    async switchActive(record) {
      record.loading_active = true
      let response = await this.$store.dispatch(
        'mission/allowanceCondition/switchActive',
        record.id
      )
      record.is_active = !!response.is_active
      record.loading_active = false
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('mission/allowanceCondition/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
